import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { useToast } from '@/shared/hooks/useToast';
import { timeOffService } from '../api/time-off.service';
import type { HolidayPayload } from '../types';

export function useCreateHoliday() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;
  const { t } = useTranslation('timeOff');
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: HolidayPayload) => timeOffService.createHoliday(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['time-off', 'holidays', orgId] });
      toast.success({ title: t('settings.toasts.holidaySaved') });
    },
  });
}
